(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/wallet-components/assets/javascripts/commission-selector.js') >= 0) return;  svs.modules.push('/components/tipsen/wallet-components/assets/javascripts/commission-selector.js');
"use strict";

const _svs$ui$reactForm = svs.ui.reactForm,
  ControlGroup = _svs$ui$reactForm.ControlGroup,
  Select = _svs$ui$reactForm.Select,
  Option = _svs$ui$reactForm.Option;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector,
  useDispatch = _ReactRedux.useDispatch;
const _svs$components$tipse = svs.components.tipsen.walletSelectors,
  selectActiveWallet = _svs$components$tipse.selectActiveWallet,
  selectCommissionOptions = _svs$components$tipse.selectCommissionOptions;
const setRetailerCommission = svs.components.tipsen.wallet.actions.setRetailerCommission;
const format = svs.utils.format;
const CommissionSelector = () => {
  const dispatch = useDispatch();
  const selectedWallet = useSelector(selectActiveWallet);
  const commissionItems = useSelector(selectCommissionOptions);
  const handleClick = data => {
    dispatch(setRetailerCommission({
      walletId: selectedWallet.id,
      commission: Number(data)
    }));
  };
  return React.createElement(ControlGroup, {
    v2: true
  }, React.createElement(Select, {
    "data-testid": "mkp-commission-selector",
    onChange: event => handleClick(event.target.value),
    v2: true,
    value: String(selectedWallet.meta.commissionPercent)
  }, commissionItems.map(_ref => {
    let value = _ref.value,
      amount = _ref.amount;
    return React.createElement(Option, {
      disabled: selectedWallet.meta.apiCommission < value,
      key: value,
      value: String(value)
    }, "".concat(value, "% (Spelpott: ").concat(format.Currency(amount), " kr)"));
  })));
};
setGlobal('svs.components.tipsen.walletComponent.CommissionSelector', CommissionSelector);

 })(window);